import { render, staticRenderFns } from "./ViewParagraph.vue?vue&type=template&id=d12f285c&scoped=true&"
import script from "./ViewParagraph.vue?vue&type=script&lang=js&"
export * from "./ViewParagraph.vue?vue&type=script&lang=js&"
import style0 from "./ViewParagraph.vue?vue&type=style&index=0&id=d12f285c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f285c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12f285c')) {
      api.createRecord('d12f285c', component.options)
    } else {
      api.reload('d12f285c', component.options)
    }
    module.hot.accept("./ViewParagraph.vue?vue&type=template&id=d12f285c&scoped=true&", function () {
      api.rerender('d12f285c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/ViewParagraph.vue"
export default component.exports